import { render, staticRenderFns } from "./DropdownSupplier.vue?vue&type=template&id=63325548&scoped=true&"
import script from "./DropdownSupplier.vue?vue&type=script&lang=js&"
export * from "./DropdownSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325548",
  null
  
)

export default component.exports